module.exports = __webpack_public_path__ + "media/custom/images/img29-e48535b91bb855fc887e9987e426419c.png";